import type { CollectionDiscoverSchema } from '~/types/product.model'
import type { UseStateType } from '~/types/utils/use-state-type'

// This is used to extract the right types from Nuxt useState
type Types = UseStateType<CollectionDiscoverSchema[] | null>

/**
 * A type-safe wrapper around `useState`
 */
export const useDiscoverCollectionState = (init: Types['firstParam'] = undefined): Types['return'] =>
  useState<Types['state']>('collections', init)
